import React, { use, useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../constant/constant";
import {
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CachedIcon from "@mui/icons-material/Cached";

function SP_ChangeSoftwareButton() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [softwares, setSoftwares] = useState([]);
  const [softUsers, setSoftUsers] = useState([]);
  const [loadingSoftwares, setLoadingSoftwares] = useState(false);
  const [loadingSoftUsers, setLoadingSoftUsers] = useState(false);

  const [selectedSoftwareCode, setSelectedSoftwareCode] = useState("");
  const [selectedSoftwareGroup, setSelectedSoftwareGroup] = useState("");

  const [confirmBeforeUpdate, setConfirmBeforeUpdate] = useState(false);
  const [forceLogoutDialog, setForceLogoutDialog] = useState(false);
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // Fetch softwares
  useEffect(() => {
    const fetchSoftwarelist = async () => {
      try {
        setLoadingSoftwares(true);
        const res = await axios.get(`${API_BASE_URL}/api/softwareslist` ,{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});
        setSoftwares(res.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingSoftwares(false);
      }
    };
    fetchSoftwarelist();
  }, []);

  // Fetch users under selected software
  useEffect(() => {
    if (!selectedSoftwareCode) return;
    (async () => {
      try {
        setLoadingSoftUsers(true);
        const res = await axios.get(
          `${API_BASE_URL}/api/softwareuser/${selectedSoftwareCode}` ,{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },}
        );
        setSoftUsers(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Error fetching Software Users:", err);
      } finally {
        setLoadingSoftUsers(false);
      }
    })();
  }, [selectedSoftwareCode]);

  // Logout function
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        await axios.post(
          `${API_BASE_URL}/logout`,
          {} ,{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },}
        );
      }
    } catch (_) {
      // ignore network errors
    } finally {
      navigate("/", { replace: true });
      localStorage.clear();
      sessionStorage.clear();
    }
  };

  // Update confirmation
  const handleConfirmUpdate = async () => {
    try {
      await axios.put(`${API_BASE_URL}/api/updateUserSoftware`, {
        softgroup: selectedSoftwareCode,
        softsubgroup: selectedSoftwareGroup,
      } ,{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});

      setConfirmBeforeUpdate(false);
      setDialogOpen(false);
      setForceLogoutDialog(true);

      setTimeout(() => {
        handleLogout();
      }, 2500);
    } catch (err) {
      console.error("Error updating:", err);
    }
  };



useEffect(() => {
    if (!forceLogoutDialog) return;
    const timer = setTimeout(() => {
      setForceLogoutDialog(false);
      setLogoutConfirmOpen(true);
    }, 4000);
    return () => clearTimeout(timer);
  }, [forceLogoutDialog]);  

  useEffect(() => {
    if (!dialogOpen) {
      setSelectedSoftwareCode("");
      setSelectedSoftwareGroup("");
    }
  }, [dialogOpen]);   
  


  return (
    <div>
      {/* Main Button */}
      <Button
        variant="outlined"
        startIcon={<CachedIcon />}
        color="secondary"
        fullWidth
        sx={{
          py: 1.5,
         // fontWeight: "bold",
          borderRadius: 3,
          textTransform: "none",
        }}
        onClick={() => setDialogOpen(true)}
      >
         Change Software
      </Button>

      {/* Change Software Dialog */}
      <Dialog  open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="sm" >
        <DialogTitle sx={{ bgcolor: "primary.main", color: "white", fontWeight: "bold" }}>
          Change Software
        </DialogTitle>

        <DialogContent dividers sx={{ p: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 , p: 2, borderRadius: 2}}>
            {/* Software Dropdown */}
            <FormControl fullWidth>
              <InputLabel>Select Software</InputLabel>
              <Select
                value={selectedSoftwareCode}
                onChange={(e) => setSelectedSoftwareCode(e.target.value)}
                label="Select Software"
              >
                {loadingSoftwares ? (
                  <MenuItem disabled>
                    <CircularProgress size={20} />
                  </MenuItem>
                ) : (
                  softwares.map((s) => (
                    <MenuItem key={s.softgroupcode} value={s.softgroupcode}>
                      {s.softwarename}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>

            {/* Group Dropdown */}
            <FormControl fullWidth>
              <InputLabel>Software Group</InputLabel>
              <Select
                value={selectedSoftwareGroup}
                onChange={(e) => setSelectedSoftwareGroup(e.target.value)}
                label="Software Group"
              >
                {loadingSoftUsers ? (
                  <MenuItem disabled>
                    <CircularProgress size={20} />
                  </MenuItem>
                ) : (
                  softUsers.map((s) => (
                    <MenuItem key={s.softsubgroupcode} value={s.softsubgroupcode}>
                      {s.sofwaredetailsname}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDialogOpen(false)} variant="outlined" color="inherit">
            Cancel
          </Button>
          <Button variant="contained" onClick={() => setConfirmBeforeUpdate(true)} color="secondary">
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Update */}
      <Dialog open={confirmBeforeUpdate} onClose={() => setConfirmBeforeUpdate(false)}>
        <DialogTitle sx={{ fontWeight: "bold" }}>Confirm Update</DialogTitle>
        <DialogContent dividers>
          <Typography>Are you sure you want to update the software and group?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmBeforeUpdate(false)}>Cancel</Button>
          <Button variant="contained" color="secondary" onClick={handleConfirmUpdate}>
            Yes, Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Logout Required Dialog */}
      <Dialog open={forceLogoutDialog}>
        <DialogTitle sx={{ bgcolor: "error.main", color: "white", fontWeight: "bold" }}>
          Logging Out
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            Software has been updated. You will be logged out automatically...
          </Typography>
        </DialogContent>
      </Dialog>

      {/* Manual Logout Confirmation */}
      <Dialog open={logoutConfirmOpen} onClose={() => setLogoutConfirmOpen(false)}>
        <DialogTitle sx={{ fontWeight: "bold" }}>Confirm Logout</DialogTitle>
        <DialogContent dividers>
          <Typography>
            Software has been updated. You need to log out and log back in to apply changes. Do you
            want to log out now?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutConfirmOpen(false)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleLogout}>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SP_ChangeSoftwareButton;
